import type { HTMLAttributes, ReactNode } from 'react';

export type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  label?: string;
  extra?: ReactNode;
};

export function Container({
  label,
  extra,
  children,
  ...props
}: ContainerProps) {
  return (
    <div {...props}>
      <header className="tlw-py-1.5 tlw-flex tlw-justify-between tlw-items-center tlw-gap-1">
        <p className="tlw-txt-zh-head-8 tlw-text-txt-black">{label}</p>

        <div className="tlw-flex tlw-items-center tlw-gap-2">{extra}</div>
      </header>

      <div>{children}</div>
    </div>
  );
}
